export const BASE_URL = process.env.REACT_APP_BASE_URL || "";
export const PUBLIC_URL = process.env.PUBLIC_URL || "";
export const USER_ID = "user_id";
